/**
 * 申込情報紹介ページのテーブルに関する処理
 */
export const checkTable = () => {
  /**
   * 一括操作用のチェックボックスを取得
   */
  // すべてのAにチェック（チェックボックス）
  const allCheckA       = document.getElementById( 'controller01' );
  // すべてのBにチェック（チェックボックス）
  const allCheckB       = document.getElementById( 'controller02' );
  // すべてのCにチェック（チェックボックス）
  const allCheckC       = document.getElementById( 'controller03' );
  // 立替金請求 すべてにチェック（チェックボックス）
  const allCheckAdvance = document.getElementById( 'controller04' );
  // A・B・C全てクリア
  const abcReset        = document.getElementById( 'controller05' );

  /**
   * テーブル内のすべてのチェックボックスを取得
   */
  // 立替金請求
  const advanceCheckElements = document.querySelectorAll( '.js-check-advance' );
  // A
  const aCheckElements       = document.querySelectorAll( '.js-check-a' );
  // B
  const bCheckElements       = document.querySelectorAll( '.js-check-b' );
  // C
  const cCheckElements       = document.querySelectorAll( '.js-check-c' );

  /**
   * A・B・C全てクリアがチャックされた時のイベント
   */
  abcReset.addEventListener( 'click', () => {
    aCheckElements.forEach( item => {
      item.checked = false;
    } );
    bCheckElements.forEach( item => {
      item.checked = false;
    } );
    cCheckElements.forEach( item => {
      item.checked = false;
    } );
    allCheckA.checked = false;
    allCheckB.checked = false;
    allCheckC.checked = false;
  } );

  /**
   * 立替金請求 がチェックされた時のイベント
   */
  const advanceCheckLength = advanceCheckElements.length;
  advanceCheckElements.forEach( item => {
    item.addEventListener( 'change', () => {
      let   advanceCheckCont   = 0;
      advanceCheckElements.forEach( item2 => {
        if ( item2.checked ) {
          advanceCheckCont++;
        }
      } );
      if ( advanceCheckCont === advanceCheckLength ) {
        allCheckAdvance.checked = true;
      } else {
        allCheckAdvance.checked = false;
      }
    } );
  } );

  /**
   * A がチェックされた時のイベント
   */
  const aCheckLength = aCheckElements.length;
  aCheckElements.forEach( item => {
    item.addEventListener( 'change', () => {
      let   aCheckCont   = 0;
      aCheckElements.forEach( item2 => {
        if ( item2.checked ) {
          aCheckCont++;
        }
      } );
      if ( aCheckCont === aCheckLength ) {
        allCheckA.checked = true;
      } else {
        allCheckA.checked = false;
      }
    } );
  } );

  /**
   * B がチェックされた時のイベント
   */
  const bCheckLength = bCheckElements.length;
  bCheckElements.forEach( item => {
    item.addEventListener( 'change', () => {
      let   bCheckCont   = 0;
      bCheckElements.forEach( item2 => {
        if ( item2.checked ) {
          bCheckCont++;
        }
      } );
      if ( bCheckCont === bCheckLength ) {
        allCheckB.checked = true;
      } else {
        allCheckB.checked = false;
      }
    } );
  } );

  /**
   * A がチェックされた時のイベント
   */
  const cCheckLength = cCheckElements.length;
  cCheckElements.forEach( item => {
    item.addEventListener( 'change', () => {
      let   cCheckCont   = 0;
      cCheckElements.forEach( item2 => {
        if ( item2.checked ) {
          cCheckCont++;
        }
      } );
      if ( cCheckCont === cCheckLength ) {
        allCheckC.checked = true;
      } else {
        allCheckC.checked = false;
      }
    } );
  } );

  /**
   * すべてのAにチェックがされた時のイベント
   */
  allCheckA.addEventListener( 'change', () => {
    if ( allCheckA.checked ) {
      aCheckElements.forEach( item => {
        item.checked = true;
      } );
    } else {
      aCheckElements.forEach( item => {
        item.checked = false;
      } );
    }
  } );

  /**
   * すべてのBにチェックがされた時のイベント
   */
  allCheckB.addEventListener( 'change', () => {
    if ( allCheckB.checked ) {
      bCheckElements.forEach( item => {
        item.checked = true;
      } );
    } else {
      bCheckElements.forEach( item => {
        item.checked = false;
      } );
    }
  } );

  /**
   * すべてのCにチェックがされた時のイベント
   */
  allCheckC.addEventListener( 'change', () => {
    if ( allCheckC.checked ) {
      cCheckElements.forEach( item => {
        item.checked = true;
      } );
    } else {
      cCheckElements.forEach( item => {
        item.checked = false;
      } );
    }
  } );

  /**
   * 立替金請求 すべてにチェックがされた時のイベント
   */
  allCheckAdvance.addEventListener( 'change', () => {
    if ( allCheckAdvance.checked ) {
      advanceCheckElements.forEach( item => {
        item.checked = true;
      } );
    } else {
      advanceCheckElements.forEach( item => {
        item.checked = false;
      } );
    }
  } );
}
